// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";

var Js_ = {};

var StorageType = {
  Js_: Js_
};

var Js_$1 = {};

function fromJs(js) {
  return {
          args: js.args,
          fieldName: js.fieldName,
          storeFieldName: js.storeFieldName,
          field: js.field,
          variables: js.variables,
          isReference: js.isReference,
          toReference: js.toReference,
          storage: js.storage,
          cache: js.cache,
          readField: js.readField,
          canRead: js.canRead,
          mergeObjects: (function (existing, incoming) {
              return js.canRead(existing, incoming);
            })
        };
}

var FieldFunctionOptions = {
  Js_: Js_$1,
  fromJs: fromJs
};

var Js_$2 = {};

function toJs(t, existing, incoming, jsFieldFunctionOptions) {
  return Curry._3(t, existing, incoming, fromJs(jsFieldFunctionOptions));
}

var FieldMergeFunction = {
  Js_: Js_$2,
  toJs: toJs
};

function mergeFunction(v) {
  return v;
}

var FieldMergeUnion = {
  mergeFunction: mergeFunction,
  true_: true
};

var Js_$3 = {
  FieldMergeUnion: FieldMergeUnion
};

function toJs$1(x) {
  if (!x) {
    return true;
  }
  var partial_arg = x._0;
  return function (param, param$1, param$2) {
    return toJs(partial_arg, param, param$1, param$2);
  };
}

var FieldMerge = {
  Js_: Js_$3,
  toJs: toJs$1
};

var Js_$4 = {};

function toJs$2(t, existing, jsFieldFunctionOptions) {
  return Curry._2(t, existing, fromJs(jsFieldFunctionOptions));
}

var FieldReadFunction = {
  Js_: Js_$4,
  toJs: toJs$2
};

var Js_$5 = {};

var KeySpecifier = {
  Js_: Js_$5
};

var Js_$6 = {};

var KeyArgsFunction = {
  Js_: Js_$6
};

function keySpecifier(v) {
  return v;
}

function keyArgsFunction(v) {
  return v;
}

var KeyArgsUnion = {
  keySpecifier: keySpecifier,
  keyArgsFunction: keyArgsFunction,
  false_: false
};

var Js_$7 = {
  KeyArgsUnion: KeyArgsUnion
};

function toJs$3(x) {
  if (typeof x === "number") {
    return false;
  } else {
    return x._0;
  }
}

var FieldPolicy_KeyArgs = {
  Js_: Js_$7,
  toJs: toJs$3
};

var Js_$8 = {};

function toJs$4(t) {
  return {
          keyArgs: Belt_Option.map(t.keyArgs, toJs$3),
          read: Belt_Option.map(t.read, toJs$2),
          merge: Belt_Option.map(t.merge, toJs$1)
        };
}

var FieldPolicy = {
  Js_: Js_$8,
  toJs: toJs$4
};

var ApolloCache;

var CanReadFunction;

var FieldNode;

var ReadFieldFunction;

var ToReferenceFunction;

export {
  ApolloCache ,
  CanReadFunction ,
  FieldNode ,
  ReadFieldFunction ,
  ToReferenceFunction ,
  StorageType ,
  FieldFunctionOptions ,
  FieldMergeFunction ,
  FieldMerge ,
  FieldReadFunction ,
  KeySpecifier ,
  KeyArgsFunction ,
  FieldPolicy_KeyArgs ,
  FieldPolicy ,
}
/* No side effect */
